import { Services, getServicePathToAPI, projectName } from '@sigma-frontend-libs/commons'
import { Macro } from '@sigma-legacy-libs/cache'

import { globalErrorHandler, macroCacheOptions, permissionPresets, request } from '@/utils'

import render from './render'

const Cache = new Macro(macroCacheOptions)
const cachedFind = Cache.wrapWithCache(async (key, service, query) => {
  const pathToAPI = getServicePathToAPI(service)

  return await request.find(pathToAPI, undefined, query)
})

export default {
  name: 'Requisites',

  props: {
    OwnerId: {
      type: String,
      default: undefined
    },

    foreign: Boolean
  },

  data() {
    return {
      items: []
    }
  },

  computed: {
    canGetRequisites() {
      return this.checkPermissions(`advanced.${Services.requisites}.get`, permissionPresets.resellerUp)
    }
  },

  mounted() {
    this.getRequisites()
  },

  methods: {
    async getRequisites() {
      if (this.canGetRequisites) {
        if (this.foreign && !this.OwnerId) {
          return false
        }

        try {
          const service = Services.requisites
          const query = { OwnerId: this.OwnerId }
          const key = [ projectName, service, 'find', JSON.stringify(query) ].filter(Boolean).join(':')
          const data = await cachedFind(key, service, query)
          if (data && Array.isArray(data.data) && data.data.length) {
            this.items = data.data
          }
        } catch (error) {
          globalErrorHandler(error)
        }
      }
    }
  },

  render
}
